/* eslint-disable */
// @ts-nocheck

import { FilterX, X } from 'lucide-react'

import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'

// Simplified interface for nuqs-based filters
interface SelectionSummaryProps {
  // Active nuqs filters
  type: string[]
  setType: (statuses: string[]) => void
  typeOptions: { value: string; label: string }[]
  activePaymentStatuses?: string[]
  setActivePaymentStatuses?: (statuses: string[]) => void
  paymentStatusOptions?: { value: string; label: string }[]
  searchQuery: string
  activeOrigins?: string[]
  setActiveOrigins?: (origins: string[]) => void
  originsOptions?: { value: string; label: string }[]
  setSearchQuery: (searchQuery: string) => void
  handleClearFilters: () => void
}

export const SelectionSummary = ({
  type,
  setType,
  typeOptions,
  activePaymentStatuses,
  setActivePaymentStatuses,
  paymentStatusOptions,
  searchQuery,
  setSearchQuery,
  handleClearFilters,
  activeOrigins,
  setActiveOrigins,
  originsOptions,
}: SelectionSummaryProps) => {
  // Check if any filters are active
  const hasActiveFilters =
    !type.includes('all') ||
    !activePaymentStatuses?.includes('all') ||
    !activeOrigins?.includes('all') ||
    searchQuery !== ''

  const handleSearchClear = () => {
    setSearchQuery('')
  }

  const handleClearAll = () => {
    handleClearFilters()
  }

  return (
    <div className="mt-2 flex flex-wrap gap-2">
      {/* Order Status Filter Badge */}
      {!type.includes('all') && (
        <Badge
          className="gap-1 rounded-full py-1.5 pl-2 pr-1"
          variant="secondary"
        >
          <span>
            Estado:{' '}
            {type
              .map(
                (s) => typeOptions.find((option) => option.value === s)?.label
              )
              .join(', ')}
          </span>
          <Button
            className="ml-1 h-4 w-4"
            onClick={() => setType(['all'])}
            size="icon"
            variant="ghost"
          >
            <X className="h-3 w-3" />
          </Button>
        </Badge>
      )}

      {/* Search Query Badge */}
      {searchQuery && (
        <Badge
          className="gap-1 rounded-full py-1.5 pl-2 pr-1"
          variant="secondary"
        >
          <span>Búsqueda: {searchQuery}</span>
          <Button
            className="ml-1 h-4 w-4"
            onClick={handleSearchClear}
            size="icon"
            variant="ghost"
          >
            <X className="h-3 w-3" />
          </Button>
        </Badge>
      )}

      {/* Legacy badges - commented out for now */}
      {/* {selectedTipo && (
        <Badge
          variant="secondary"
          className="gap-1 rounded-full py-1.5 pl-2 pr-1"
        >
          <span>
            Tipo:{' '}
            {tipoOptions.find((option) => option.value === selectedTipo)?.label}
          </span>
          <Button
            variant="ghost"
            size="icon"
            className="ml-1 h-4 w-4"
            onClick={() => setSelectedTipo('')}
          >
            <X className="h-3 w-3" />
          </Button>
        </Badge>
      )} */}

      {/* {personFilters.map((filter, index) => (
        <Badge
          key={`person-${index}`}
          variant="secondary"
          className="gap-1 rounded-full py-1.5 pl-2 pr-1"
        >
          <span>{filter.label}</span>
          <Button
            variant="ghost"
            size="icon"
            className="ml-1 h-4 w-4"
            onClick={() => handleRemovePersonFilter(index)}
          >
            <X className="h-3 w-3" />
          </Button>
        </Badge>
      ))} */}

      {/* {(selectedProvincia || selectedMunicipio) && lugarLabel && (
        <Badge
          variant="secondary"
          className="gap-1 rounded-full py-1.5 pl-2 pr-1"
        >
          <span>{lugarLabel}</span>
          <Button
            variant="ghost"
            size="icon"
            className="ml-1 h-4 w-4"
            onClick={() => {
              setSelectedProvincia('')
              setSelectedMunicipio('')
            }}
          >
            <X className="h-3 w-3" />
          </Button>
        </Badge>
      )} */}

      {/* {dateRange.from && (
        <Badge
          variant="secondary"
          className="gap-1 rounded-full py-1.5 pl-2 pr-1"
        >
          <span>
            {dateTypeOptions.find((dt) => dt.value === selectedDateType)?.label}
            :{' '}
            {dateRange.to
              ? `${format(dateRange.from, 'd MMM', {
                  locale: es,
                })} - ${format(dateRange.to, 'd MMM', { locale: es })}`
              : format(dateRange.from, 'd MMM yyyy', { locale: es })}
          </span>
          <Button
            variant="ghost"
            size="icon"
            className="ml-1 h-4 w-4"
            onClick={() => setDateRange({ from: undefined, to: undefined })}
          >
            <X className="h-3 w-3" />
          </Button>
        </Badge>
      )} */}

      {/* {(amountRange.min || amountRange.max) && (
        <Badge
          variant="secondary"
          className="gap-1 rounded-full py-1.5 pl-2 pr-1"
        >
          <span>
            Importe: {amountRange.min || '0'} - {amountRange.max || '∞'}
          </span>
          <Button
            variant="ghost"
            size="icon"
            className="ml-1 h-4 w-4"
            onClick={() => setAmountRange({ min: '', max: '' })}
          >
            <X className="h-3 w-3" />
          </Button>
        </Badge>
      )} */}

      {/* {selectedFilterCriteria.length > 0 && (
        <Badge
          variant="secondary"
          className="gap-1 rounded-full py-1.5 pl-2 pr-1"
        >
          <span>Criterios: {selectedFilterCriteria.length}</span>
          <Button
            variant="ghost"
            size="icon"
            className="ml-1 h-4 w-4"
            onClick={() => setSelectedFilterCriteria([])}
          >
            <X className="h-3 w-3" />
          </Button>
        </Badge>
      )} */}

      {/* {activeFilters.length > 0 &&
        activeFilters.map((filter, index) => (
          <Badge
            key={index}
            variant="secondary"
            className="gap-1 rounded-full py-1.5 pl-2 pr-1"
          >
            <span>
              {filter.name}: {filter.value}
            </span>
            <Button
              variant="ghost"
              size="icon"
              className="ml-1 h-4 w-4"
              onClick={() => {
                setActiveFilters(activeFilters.filter((_, i) => i !== index))
              }}
            >
              <X className="h-3 w-3" />
            </Button>
          </Badge>
        ))} */}

      {/* Clear All Filters Button */}
      {hasActiveFilters && (
        <Button
          className="h-7 gap-1 text-xs"
          onClick={handleClearAll}
          size="sm"
          variant="ghost"
        >
          <FilterX className="h-3.5 w-3.5" />
          Limpiar filtros
        </Button>
      )}
    </div>
  )
}
